
















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

const module = namespace('ToolStore');

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class App extends Vue {
    @module.Action('init') private init!: () => void;

    protected created() {
        this.init();
    }
}
